import styled from 'styled-components';

export const OuterPageWrapper = styled.div.attrs({ className: 'full-width' })`
  @media (width >= 57rem) {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 100vh;
    background: linear-gradient(90deg, var(--white) 49.5%, var(--grey-50) 49.5%);
  }
`;

export const InnerPageWrapper = styled.div`
  max-width: 945px;

  @media (width >= 57rem) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
`;

export const ContentWrapper = styled.main`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  padding-inline: var(--spacing-large);

  @media (width >= 57rem) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
    padding-block: var(--spacing-large);
  }
`;

export const CheckOutDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large);

  & section {
    padding-block: var(--spacing-small);
  }

  @media (width >= 57rem) {
    order: -1;
    max-width: 444px;
    padding-inline: 0 42px;
  }
`;

export const OrderDetails = styled.section`
  @media (width >= 57rem) {
    width: 447px;
  }
`;
